import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { CoursesFacade } from '../facades/courses.facade';

export function coursesCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const coursesFacade = inject(CoursesFacade);
        coursesFacade.clear();

        return true;
    };
}
